import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M12 .375C18.42.375 23.625 5.58 23.625 12S18.42 23.625 12 23.625.375 18.42.375 12 5.58.375 12 .375"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#D9DCDD",
  "stroke-width": ".75",
  d: "M12 .375C18.42.375 23.625 5.58 23.625 12S18.42 23.625 12 23.625.375 18.42.375 12 5.58.375 12 .375Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#414042",
  d: "M13.86 6.48a4.057 4.057 0 0 1 5.015 3.957c0 1.716-1.13 2.951-2.058 3.88l-.007.007-3.422 3.31a1.875 1.875 0 0 1-2.763.015L7.19 14.324l-.007-.007c-.928-.928-2.058-2.157-2.058-3.88a4.063 4.063 0 0 1 6.874-2.932 4.06 4.06 0 0 1 1.86-1.025m-7.485 3.957c0 1.153.745 2.05 1.692 2.996l3.435 3.325.032.033a.625.625 0 0 0 .937-.006l.037-.039 3.432-3.32c.943-.944 1.685-1.845 1.685-2.989v-.003a2.806 2.806 0 0 0-4.902-1.879l-.011.012a.976.976 0 0 1-1.424 0l-.009-.01a2.812 2.812 0 0 0-4.904 1.88"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }